import { useTranslation } from 'react-i18next'
import { IconButton } from '@/ui'
import { useLanguage } from '@/lib/language.js'

/**
 * A language toggle button that flips between English and Arabic. Shows the
 * language you'll SWITCH TO (not the current one) — same convention as
 * ThemeToggle, whose icon shows the mode a click leads to, not the mode
 * you're in.
 */
export function LanguageToggle({ className }: { className?: string } = {}) {
  const { t } = useTranslation()
  const { language, setLanguage } = useLanguage()

  const handleClick = () => {
    setLanguage(language === 'en' ? 'ar' : 'en')
  }

  const target = language === 'en' ? { code: 'ar', name: 'العربية' } : { code: 'en', name: 'English' }

  return (
    <IconButton
      icon={<span className="text-label-sm font-semibold uppercase tracking-tight">{target.code}</span>}
      label={t('nav.language', { language: target.name })}
      onClick={handleClick}
      variant="standard"
      className={className}
    />
  )
}
